import { ContentContainer, PageLayout, PageTitle } from "@/components/layout";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";

import { ParamsForm } from "../components/params-form";
import { ReasonsTab } from "../components/reasons-tab";

export function PriceRemarkSettings() {
  return (
    <PageLayout>
      <PageTitle
        title="Configurações — Etiqueta Remarcados"
        description="Parâmetros de operação e catálogo de motivos de justificativa."
      />
      <ContentContainer>
        <Tabs defaultValue="parametros" className="w-full">
          <TabsList>
            <TabsTrigger value="parametros">
              Parâmetros de operação
            </TabsTrigger>
            <TabsTrigger value="motivos">Motivos de justificativa</TabsTrigger>
          </TabsList>
          <TabsContent value="parametros" className="pt-4">
            <ParamsForm />
          </TabsContent>
          <TabsContent value="motivos" className="pt-4">
            <ReasonsTab />
          </TabsContent>
        </Tabs>
      </ContentContainer>
    </PageLayout>
  );
}

export default PriceRemarkSettings;
